import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../store/store.interface";
import { makeProductRequest } from "../../product-card/product";
import { ActionStatus } from "../../../common/constants/action-status";
import { Catalog } from "../../../common/constants/catalog";
import { SHARPEN_PROGRAM_ID } from "../constants/sharpen-page-type.constants";

export const fetchAllSharpenProducts = createAsyncThunk(
  'sharpen/getAllSharpenProducts',
  async (_: undefined) => {
    return await makeProductRequest(Catalog.he, SHARPEN_PROGRAM_ID);
  }, {
    condition: ((_arg, { getState }) => {
      const state = getState() as StoreState;
      return state.sharpenProductDataState.sharpenSearchServiceProductData.status !== ActionStatus.loading;
    })
  }
);
